import React from 'react';
import { IDataGridCommonRenderProps } from './types';

export const DataGridContext = React.createContext<
  IDataGridCommonRenderProps<any>
>({} as IDataGridCommonRenderProps<any>);

export default DataGridContext;
